module.exports = __webpack_public_path__ + "img/16.8842af89.png";